export default __webpack_public_path__ + "static/media/Bandeau 22bis HD.9211a18c.jpg";